import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=390b67b0&scoped=true"
import script from "./CustomForm.vue?vue&type=script&lang=js"
export * from "./CustomForm.vue?vue&type=script&lang=js"
import style0 from "./CustomForm.vue?vue&type=style&index=0&id=390b67b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b67b0",
  null
  
)

export default component.exports